import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {GuardService} from '../services/guard.service';

@Injectable()
export class NonAuthUsersGuard {

  constructor(private _router: Router,
              private _guardService: GuardService) {
  }

  async canActivate() {
    await this._guardService.isAuth();

    if (this._guardService.auth)
      return this._router.createUrlTree(['']);
    else
      return true;
  }
}
